import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SiteLogo from '../assets/img/site-logo.png';
import Google from '../assets/img/final/google.png';
import { CircleAlert, X } from 'lucide-react';
import apiHelper from '../apiHelper';
const Signin = () => {
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token");
  const auth_error = queryParams.get("auth_error");

  // State to store user details
  const [userDetails, setUserDetails] = useState(null);

  const fetchUserDetails = async (token) => {
    try {
      const response = await apiHelper('users/profile/', 'GET', null, {
        Authorization: `Bearer ${token}`,
      });
      if (response.ok) {
        const data = await response.json();
        console.log("Fetched user details:", data);
        setUserDetails(data);
        return data; // Return the fetched data
      } else {
        const error = await response.json();
        console.error("Failed to fetch user details:", error);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      return null;
    }
  };

  if (token) {
    (async () => {
      try {
        localStorage.setItem('token', token);
        const user_name = queryParams.get("u");
        const fetchedUserDetails = await fetchUserDetails(token);
        if (fetchedUserDetails) {
          const user_data = {
            "token": token,
            "name": user_name,
            "userDetails": fetchedUserDetails
          };
          localStorage.setItem('user', JSON.stringify(user_data));
          history.push('/welcome');
        } else {
          console.error("User details fetch failed, not redirecting");
        }
      } catch (error) {
        console.error("Sign-in error:", error);
      }
    })();
  }

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      // Fetch and parse user details from localStorage
      history.push('/welcome');
    }

    document.body.classList.add('signin-body-bg');
    return () => document.body.classList.remove('signin-body-bg');
  }, []);

  const handleGoogleClick = () => {

    const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';
    // const REDIRECT_URI = 'https://erp-backend.mistermobile.sg/api/users/google_callback/';
    // const REDIRECT_URI = 'http://localhost:8000/api/users/google_callback/';
    // const REDIRECT_URI = 'https://erp-backend.mistermobile.sg/api/users/google_callback/';
    // const REDIRECT_URI = 'http://localhost:8000/api/users/google_callback/';
  //  const REDIRECT_URI = 'https://deverp-backend.mistermobile.sg/api/users/google_callback/'; /// fordev
    const REDIRECT_URI = 'https://stageerp-backend.mistermobile.sg/api/users/google_callback/'; /// for stage 

    const scope = [
      'https://www.googleapis.com/auth/userinfo.email',
      'https://www.googleapis.com/auth/userinfo.profile'
    ].join(' ');

    const params = {
      response_type: 'code',
      //client_id: '536743536051-ff3sdar5mmjhcjmbl7l6pphcb7al8mjd.apps.googleusercontent.com', //live
      // client_id: '536743536051-1il72lq723noies5c3gplg3rl2dgdigj.apps.googleusercontent.com', //live
      // client_id: '536743536051-kj7cp95gnhkfqqm32julgge7uqomjrkj.apps.googleusercontent.com', // local
      client_id: '536743536051-rbifv3ub9l1tr8pnknnhiqpl0pvn2hdf.apps.googleusercontent.com', //live stage
      // client_id: '536743536051-232gicohvv8an0mptoj2vvoqb17pdc90.apps.googleusercontent.com', //dev
      redirect_uri: `${REDIRECT_URI}`,
      prompt: 'select_account',
      access_type: 'offline',
      scope
    };

    const urlParams = new URLSearchParams(params).toString();
    window.location = `${GOOGLE_AUTH_URL}?${urlParams}`;
  };

  return (
    <div className="mm-signinmodule">
      {auth_error &&
        <div
          style={{
            color: 'red',
            backgroundColor: '#fde1e4',
            padding: '10px 8px',
            borderRadius: '8px',
            border: '1px solid',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            left: '50%',
            top: '12px',
            transform: 'translateX(-50%)',
            gap: '15px',
            marginBottom: '10px',
          }}
          id="alert-message"
        >
          <CircleAlert style={{ marginRight: 'auto', width: '20px', height: '20px' }} />
          <p style={{ fontSize: '12px', margin: 0 }}>
            <b>Sign In Failed</b> - {auth_error}
          </p>
          <X
            style={{
              marginLeft: 'auto',
              cursor: 'pointer',
              width: '20px',
              height: '20px',
            }}
            onClick={() => {
              document.getElementById('alert-message').style.display = 'none';
            }}
          />
        </div>
      }

      <div className="middle-portion-setup">
        <div className="signin-middle-type">
          <div className="mistermobile-logo">
            <img src={SiteLogo} alt="Site Logo" />
          </div>
          <div className="heading-main">
            <h1>Sign In</h1>
            <p className='sub-heading'>Welcome! Sign In your account with Google.</p>
          </div>
          <div className="signin-btn">
            <button className="google-btn" onClick={handleGoogleClick}>
              <img
                src={Google}
                alt="Google icon"
              />
              Continue with Google
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
